class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.items = [];
    this.bindEvents();
    this.setHeaderCartIconAccessibility();
  }

  async init() {
    this.cart = await window.cartService.load();

    window.cartService.subscribe(cart => {
      this.cart = cart;
      this.render(cart);
      this.updateSubtotal(cart);
      this.emptyCartState(cart);
    });
    

    window.cartService.load();
  }

  bindEvents() {
    this.addEventListener('click', e => {
      if (e.target.matches('.qtyplus1, .qtyminus1')) {
        e.preventDefault();
        const wrap = e.target.closest('.qty-box-set');
        const input = wrap?.querySelector('.quantity-selector');
        
        if (!input) return;
        const cart = window.cartService.cart;
        const variantId = input.dataset.variantId;
        const selectedElement = cart.items.find(element => element.variant_id == variantId);
        const max = selectedElement.properties.maxQty;
        

        let qty = parseInt(input.value) || 0;

        qty = e.target.classList.contains('qtyplus1')
          ? Math.min(max, qty + 1)
          : Math.max(0, qty - 1);

        window.cartService.change(variantId, qty);
      }

      const removeBtn = e.target.closest('.cart__remove');
      if (removeBtn) {
        e.preventDefault();
        const id = removeBtn.dataset.variantId;
        window.cartService.change(id, 0);
      }
    });

    this.addEventListener('change', e => {
      if (!e.target.matches('.quantity-selector')) return;
      const cart = window.cartService.cart;
      const variantId = e.target.dataset.variantId;      
      const selectedElement = cart.items.find(element => element.variant_id == variantId);
      const max = selectedElement.properties.maxQty;

      let qty = Number(e.target.value);
      const min = Number(e.target.min) || 0;

      qty = Math.min(max, Math.max(min, qty));
      

      window.cartService.change(
        e.target.dataset.variantId,
        qty
      );
    });
  }

  updateTotalItem(priceEl, qty, price) {
    const cart = {};

    const priceCount = this.formatMoney(price * qty);

    if (priceEl.dataset.variantId != variantId) return;

    priceEl.textContent = priceCount;
    cart.total_price = priceCount;
    this.updateSubtotal(cart);
  }

  render(cart) {
    const container = this.querySelector('.row-items');
    if (!container || cart.status == 422) return;

    container.innerHTML = cart.items.map(item => this.cartItemHTML(item))
      .join('');
  }

    cartItemHTML(item) {
      const productImage = item.image ?? globalThis.noImage;
      const variantTitle =
        item.variant_title && !item.variant_title.includes('Default')
          ? `<br><small>${item.variant_title}</small>`
          : '';

      const vendorHTML = item.vendor
        ? `<p>${item.vendor}</p>`
        : '';

      const propertiesHTML = item.properties
        ? Object.entries(item.properties)
            .filter(([_, v]) => v)
            .map(([k, v]) => `
              <li class="product-details__item product-details__item--property">
                <span class="product-details__item-label">${k}: </span>
                <span>
                  ${
                    typeof v === 'string' && v.includes('/uploads/')
                      ? `<a href="${v}">Uploaded File</a>`
                      : v
                  }
                </span>
              </li>
            `)
            .join('')
        : '';

      const hasDiscount = item.original_line_price > item.final_line_price;

      return `
      <div class="cart__row-item" data-variant-id="${item.variant_id}">
        <div class="grid--full cart__row--table-large text-center">

          <!-- PRODUCT -->
          <div class="grid__item four-tenths">
            <div class="grid cart_items">

              <div class="grid__item ">
                <a href="${item.url}" class="cart__image">
                  <img src="${productImage}" alt="${item.title}">
                </a>
              </div>
            </div>
          </div>

          <!-- QTY / TOTAL / REMOVE -->
          <div class="grid__item six-tenths">
            <div class="grid--full cart__row--table-large item-information-drawer">
              <div class="grid__item  cart-title">
                <a href="${item.url}" class="h5">${item.product_title}</a>
                ${variantTitle}
                ${vendorHTML}

              
              </div>

              <!-- QTY -->
              <div class="grid__item qty-box-wrapper  text-center">
                <span class="h4 cart__large-labels">Quantity</span>
                <div class="qty-box-set">
                  <button type="button" class="qtyminus1">-</button>
                  <input
                    type="number"
                    class="quantity-selector cart-number"
                    data-variant-id="${item.variant_id}"
                    value="${item.quantity}"
                    min="0">
                  <button type="button" class="qtyplus1">+</button>
                </div>
              </div>

              <!-- TOTAL -->
              <div class="grid__item ">
                <span class="h4 cart__large-labels">Total</span>
                <span class="h5">

                  ${
                    hasDiscount
                      ? `<small class="cart-item__original-price">
                          <s>${this.formatMoney(item.original_line_price)}</s>
                        </small>`
                      : ''
                  }

                  <div class="qb-total-line-item" data-id="${item.key}" data-variant-id="${item.variant_id}">
                    ${this.formatMoney(item.final_line_price)}
                  </div>

                </span>

                ${
                  hasDiscount && item.discounts
                    ? item.discounts
                        .map(d => `<small class="cart-item__discount">${d.title}</small>`)
                        .join('')
                    : ''
                }
              </div>
            </div>
          </div>

          <div class="remove-item trash-icon">
               <!-- REMOVE -->
              <div class="grid__item  text-center">
                <span class="h4 cart__large-labels">Remove</span>
                <a href="#" class="cart__remove" data-key="${item.key}" data-variant-id="${item.variant_id}">
                  <i class="fa fa-trash"></i>
                </a>
              </div>
          </div>
        </div>
      </div>
      `;
    }

  /* ===============================
     OPEN / CLOSE
  =============================== */
  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('.header-cart');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.addEventListener('click', e => {
      e.preventDefault();
      this.open();
    });
  }

  updateSubtotal(cart) {
      this.querySelectorAll('.cart__subtotal .hidePrice').forEach(el => {
        el.textContent = this.formatMoney(cart.total_price);
      });
  }

  emptyCartState(cart) {
      if (!cart) return;

      const tableItems = this.querySelectorAll('.table-items');
      const emptyCart = this.querySelectorAll('.cart_empty_msg');
      const footer = this.querySelector('.drawer__footer');

      if (cart.item_count === 0) {

        tableItems.forEach(el => {
          el.classList.add('cart-drawer__items--hide');
          el.classList.remove('cart-drawer__items--show');
        });

        emptyCart.forEach(el => {
          el.classList.add('cart-drawer__items--show');
          el.classList.remove('cart-drawer__items--hide');
        });

        footer.classList.add('cart-drawer__items--hide');
        footer.classList.remove('cart-drawer__items--show');

        this.querySelectorAll('.cart__subtotal .hidePrice')
          .forEach(el => {
            el.textContent = this.formatMoney(0);
          });

      } else {

        tableItems.forEach(el => {
          el.classList.remove('cart-drawer__items--hide');
          el.classList.add('cart-drawer__items--show');
        });

        emptyCart.forEach(el => {
          el.classList.remove('cart-drawer__items--show');
          el.classList.add('cart-drawer__items--hide');
        });

        footer.classList.remove('cart-drawer__items--hide');
        footer.classList.add('cart-drawer__items--show');

      }
  }

  updateEmptyState(cart) {
    this.classList.toggle('is-empty', cart.item_count === 0);
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
